import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "base-table-panel uk-container" }
const _hoisted_2 = {
  key: 0,
  class: "uk-margin-large-top",
  "uk-spinner": "ratio: 2"
}
const _hoisted_3 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_pagination = _resolveComponent("the-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "default"),
          (_ctx.paginated)
            ? (_openBlock(), _createBlock(_component_the_pagination, {
                key: 0,
                class: "uk-flex uk-flex-right uk-margin-small-bottom uk-margin-small-right",
                onInputChanged: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('paginate')))
              }))
            : _createCommentVNode("", true)
        ]))
  ]))
}